import { render, staticRenderFns } from "./NpaResultForm.vue?vue&type=template&id=49cb33ad&scoped=true"
import script from "./NpaResultForm.vue?vue&type=script&lang=js"
export * from "./NpaResultForm.vue?vue&type=script&lang=js"
import style0 from "./NpaResultForm.vue?vue&type=style&index=0&id=49cb33ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb33ad",
  null
  
)

export default component.exports